import React, { useEffect } from 'react';
import { matchPath } from 'react-router-dom';
import { Button, Skeleton } from 'ui';
import { routes } from 'constants/config';
import { hasFeatureFlags } from 'utils/features';
import useFetch from '../../shared/hooks/useFetch';
import RetakeLessonReassign from './RetakeLessonReassign';

const isLibraryPath = pathname => !!matchPath(pathname, { path: '/library' });

export const getRetakeUrl = ({ pathname }, pathId, lessonId, journeyId) => {
  const isLearningLibraryPath = isLibraryPath(pathname);

  if (isLearningLibraryPath) {
    return pathId
      ? routes.LIBRARY_PATH_LESSON_RETAKE(pathId, lessonId)
      : routes.LIBRARY_LESSON_RETAKE(lessonId);
  }

  if (journeyId) {
    return pathId
      ? routes.JOURNEY.PATH_LESSON_RETAKE(journeyId, pathId, lessonId)
      : routes.JOURNEY.LESSON_RETAKE(journeyId, lessonId);
  }

  return pathId
    ? routes.PATH_LESSON_RETAKE(pathId, lessonId)
    : routes.LESSON_RETAKE(lessonId);
};

export default function RetakeLesson({ location, match: { params } }) {
  const { pathId, lessonId, journeyId } = params;
  const retakeUrl = getRetakeUrl(location, pathId, lessonId, journeyId);
  const { loading, error, data = {} } = useFetch(retakeUrl);
  const maximumAttemptsFlag = hasFeatureFlags(['learning_maximum_attempts']);
  // Allow Page Error Boundary handles api errors
  useEffect(() => {
    if (error) {
      throw new Error(error);
    }
  }, [error]);

  return (
    <div className="basic_form retake_lesson">
      {loading ? (
        <>
          <Skeleton count={2} wrapper="h2" />
          <hr />
          <Skeleton count={2} wrapper="h2" />
        </>
      ) : (
        <>
          <>
            <h2>
              {t('learning.lessons.retake.failed_lesson', {
                score: data.progressScore,
                lesson_title: data.lessonTitle,
                retake_score: data.retakeScore,
              })}
            </h2>
            {maximumAttemptsFlag ? (
              <RetakeLessonReassign
                totalAttempts={data.totalAttempts}
                maximumAttemptsLimitCheck={data.maximumAttemptsLimitCheck}
                lessonMaximumAttempts={data.lessonMaximumAttempts}
                backToPathHTMLLink={data.backToPathHTMLLink}
              />
            ) : (
              <h2>{t('learning.lessons.retake.try_again')}</h2>
            )}
            {maximumAttemptsFlag &&
              (data.lessonMaximumAttempts < 1 ||
                data.maximumAttemptsLimitCheck) && (
                <Button customColor url={data.retakeHTMLLink}>
                  {t('learning.lessons.retake.lesson')}
                </Button>
              )}
            {!maximumAttemptsFlag && (
              <Button customColor url={data.retakeHTMLLink}>
                {t('learning.lessons.retake.lesson')}
              </Button>
            )}
            <hr />
            <h2>
              {t('progress.incorrect_questions', {
                count: data.incorrectQuestionCount,
              })}
            </h2>
            <table className="table table-striped questions">
              <tbody>
                {data.incorrectQuestions.map(question => (
                  <tr key={question.questionId}>
                    <td>{question.questionText}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </>
        </>
      )}
    </div>
  );
}
